import React from "react";
import { IonPage, IonIcon } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import { magnetOutline } from "ionicons/icons";

export const Error404 = () => (
  <IonPage>
    <div className="h-full pt-16 pb-12 flex flex-col bg-white">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 flex justify-center">
          <IonIcon className="w-32 h-32 text-primary" icon={magnetOutline} />
        </div>
        <div className="py-16">
          <div className="text-center">
            <p className="text-sm font-semibold text-primary uppercase tracking-wide">
              <FormattedMessage id="404 error" />
            </p>
            <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              <FormattedMessage id="Page not found" />
            </h1>
            <p className="mt-2 text-base text-gray-500">
              <FormattedMessage id="Sorry find" />
            </p>
            <div className="mt-6">
              <a href="/news" className="text-base font-medium text-primary">
                <FormattedMessage id="Go back home" />
                <span aria-hidden="true"> &rarr;</span>
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  </IonPage>
);
